// extracted by mini-css-extract-plugin
export default {"winnerContainer":"Winner_winnerContainer__uLJiW","place":"Winner_place__5Rw+M","tgName":"Winner_tgName__knn8o"};